import { render, staticRenderFns } from "./PlacementListTable.vue?vue&type=template&id=562e43fc"
import script from "./PlacementListTable.vue?vue&type=script&lang=js"
export * from "./PlacementListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports